import React from 'react'
import { connect } from 'react-redux'
import { Control, getField } from 'react-redux-form'
import PropTypes from 'prop-types'

import SimpleSelectControl from './SimpleSelectControl'
import TinyMCEControl from './TinyMCEControl'
import * as v from './validations'
import MultiSelectControl from './MultiSelectControl'
import DateControl from './DateControl'
import CustomSelectControl from './CustomSelectControl'
import RangeSliderControl from './RangeSliderControl'
import SwitchControl from './SwitchControl'

class Field extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    //console.log("Updating validations from mount of", this.props.model);
    Field.updateValidations(this.props.form, this.props)
  }

  componentWillUnmount() {
    //console.log("Remove validations from unmount of", this.props.model);
    this.props.form.setFieldValidations(this.props.model, null)
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const propsChanged = key => {
      const old = prevProps[key]
      const now = this.props[key]

      return old !== now
    }
    /*
     * We can't use === comparison between two arrays of functions.  Well, we can, but it causes
     * infinite re-rendering
     */
    const validateChanged =
      (prevProps.validate || []).length !== (this.props.validate || []).length
    const typeChanged = propsChanged('type')
    const controlChanged = propsChanged('control')
    const requiredChanged = propsChanged('required')
    const oldModel = prevProps.model
    const nowModel = this.props.model
    const modelChanged = oldModel !== nowModel
    const form = this.props.form

    if (
      form &&
      (modelChanged ||
        validateChanged ||
        typeChanged ||
        controlChanged ||
        requiredChanged)
    ) {
      if (modelChanged) {
        //console.log("Model changed from", oldModel, "to", nowModel, "resetting field validations");
        form.setFieldValidations(oldModel, null)
      }

      /*
       *console.log("Updating validations of", this.props.model, "because",
       *    { modelChanged, validateChanged, typeChanged, controlChanged, requiredChanged});
       */
      Field.updateValidations(form, this.props)
    }
  }

  static updateValidations(form, props) {
    //This should force a re-validate by creating a new object
    let validate = props.validate ? [...props.validate] : []

    if (props.required) {
      validate = [v.required(), ...validate]
    }

    //TinyMCE has to validate itself.
    /*
     *if(props.type === 'tinymce' || props.control === TinyMCEControl) {
     *    validate = [];
     *}
     */
    //console.log("Setting validations", validate, "for", props.model)
    form.setFieldValidations(props.model, validate)
  }

  render() {
    const {
      id,
      label,
      model,
      type,
      required,
      showRequired,
      placeholder,
      labelSrOnly,
      labelTop,
      errors,
      showValidationErrors,
      help,
      control,
      children,
      description,
      ...props
    } = this.props
    let error

    for (const errorKey in errors) {
      const e = errors[errorKey]

      if (typeof e === 'string') {
        error = e
        break
      }
    }

    const validationClass = showValidationErrors ? 'has-error' : ''
    /*
     * The TinyMCE component does jquery lookups by ID
     * and will fail if the ID contains '.'
     */
    const theId = (id || model).replace(/\./g, '_')

    //console.log("Rendering field", theId, "with", ct);

    const descriptionElement = () => {
      return description ? (
        <div className="text-muted">
          <i>{description}</i>
        </div>
      ) : null
    }
    const labelElement = inner => {
      const labelSrOnlyInner = (!label && placeholder) || labelSrOnly
      const labelText = label || (!labelSrOnly && placeholder)

      return (
        (inner || labelText) && (
          <label
            className={`control-label ${labelSrOnlyInner ? `sr-only` : ''} ${
              labelTop ? `form-label-top` : ''
            }`}
            htmlFor={theId}
            key={`label-${theId}`}>
            {inner}
            {labelText}
            {(required || showRequired) && '*'}
          </label>
        )
      )
    }
    const elementClass = (() => {
      switch (type && type.toLowerCase()) {
        case 'checkbox':
        case 'toggle':
        case 'radio':
          return ''
        case 'simpleselect':
          return ''
        case 'multiselect':
          return ''
        default:
          return `form-control ${this.props.largeTextInput ? 'input-lg' : ''}`
      }
    })()
    const guessControl = () => {
      switch (type && type.toLowerCase()) {
        case 'customselect':
          return CustomSelectControl
        case 'tinymce':
          return TinyMCEControl
        case 'simpleselect':
          return SimpleSelectControl
        case 'multiselect':
          return MultiSelectControl
        case 'datetime':
          return DateControl
        case 'checkbox':
          return Control.checkbox
        case 'select':
          return Control.select
        case 'textarea':
          return Control.textarea
        case 'toggle':
          return SwitchControl
        case 'file':
          return Control.file
        case 'range':
          return RangeSliderControl
        default:
          return Control
      }
    }
    const ThisControl = control || guessControl()
    /*
     * Passing a `control` prop to the element will break things
     * I have no idea why
     */
    const rest = { ...props }

    delete rest.control
    delete rest.largeTextInput
    delete rest.validateAction
    delete rest.inlineFormAction
    delete rest.validate
    delete rest.form

    //console.log("Creating element from", Control, this.props.largeTextInput, rest, elementClass);

    const inputElement = (
      <ThisControl
        key={theId}
        id={theId}
        type={type}
        model={model}
        className={elementClass}
        children={children}
        placeholder={
          placeholder && `${placeholder} ${required || showRequired ? ' *' : ''}`
        }
        {...rest}
      />
    )

    //console.log("InputElement for", theId, "of type", type, "with component type:\n", ct, "is:\n", inputElement);

    const normalRender = () => {
      return !this.props.inlineFormAction
        ? [labelElement(), descriptionElement(), inputElement]
        : inputElement
    }
    const checkRender = () => {
      return labelElement(inputElement)
    }
    const fieldClass = () => {
      switch (type && type.toLowerCase()) {
        case 'checkbox':
          return 'checkbox'
        case 'radio':
          return 'radio'
        default:
          return 'form-group'
      }
    }
    const renderInput = () => {
      switch (type) {
        case 'radio':
        case 'checkbox':
        case 'toggle':
          return checkRender()
        default:
          return normalRender()
      }
    }

    /*
     *console.log({
     *    model,
     *    showValidationErrors,
     *    errors
     *});
     */

    if (this.props.inlineFormAction) {
      return (
        <div className={`${fieldClass()} ${validationClass}`}>
          {labelElement()}
          <div className="input-group">
            {renderInput()}
            <div className="input-group-btn">{this.props.inlineFormAction}</div>
          </div>

          {(!type ||
            (type &&
              !(
                type.toLowerCase() === 'toggle' ||
                type.toLowerCase() === 'checkbox' ||
                type.toLowerCase() === 'radio'
              ))) && (
            <div className="help-block">
              {(showValidationErrors && error && <span>{error}</span>) || help}
            </div>
          )}
        </div>
      )
    }

    return (
      <div className={`${fieldClass()} ${validationClass}`}>
        {renderInput()}
        {(!type ||
          (type &&
            !(
              type.toLowerCase() === 'toggle' ||
              type.toLowerCase() === 'checkbox' ||
              type.toLowerCase() === 'radio'
            ))) && (
          <div className="help-block">
            {(showValidationErrors && error && <span>{error}</span>) || help}
          </div>
        )}
      </div>
    )
  }
}

Field.propTypes = {
  form: PropTypes.object.isRequired
}

function mapStateToProps(state, { model }) {
  const formModel = model.substring(0, model.lastIndexOf('.'))
  const form = getField(state, formModel)
  const field = getField(state, model)

  //console.log("Field =", field, "for model =", model, "in state", state);

  /*
   *console.log({
   *    model,
   *    form,
   *    field,
   *});
   */

  return {
    errors: field && field.errors,
    showValidationErrors:
      field &&
      !field.pending &&
      (!field.pristine || field.touched || form.submitted || form.submitFailed) &&
      !field.valid
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Field)
